const customerPath = {
  customers: '/customer',
  customer: (id = ':id') => `/customer/${id}`,
  orderEntry: '/customer/order-entry',
};

export default customerPath;
